import $ from "jquery";


function reset() {
  $('.size_calculator_f826__unit').removeClass('active');
  $('.size_calculator_f826__table').removeClass('show');
  $('.size_calculator_f826__notice').removeClass('show');
  $('.size_calculator_f826__range_slider_number').removeClass('show');
}

function switch_unit(unit) {
  $('.size_calculator_f826').removeClass('kg-active');
  $('.size_calculator_f826').removeClass('lbs-active');
  if(unit == 'kg') {
    $('.size_calculator_f826').addClass('kg-active');
    $('#range_kg').val($('#range_kg').attr('min'));
    $('#range_kg').change();
  }
  if(unit == 'lbs') {
    $('.size_calculator_f826').addClass('lbs-active');
    $('#range_lbs').val($('#range_lbs').attr('min'));
    $('#range_lbs').change();
  }
}

function show_sizes(number, unit) {
  $('.size_calculator_f826__size').removeClass('show');
  $('.size_calculator_f826__size').each(function(){
    number = parseInt(number);
    if(unit == 'kg') {
      var kg_from = parseInt($(this).attr('data-kg-from'));
      var kg_to = parseInt($(this).attr('data-kg-to'));
      var kg_to = $(this).attr('data-kg-to');
      if(kg_to == '+') {
        kg_to = 99;
      } else {
        kg_to = parseInt(kg_to);
      }
      if(number >= kg_from && number <= kg_to) {
        $(this).addClass('show');
        $('.size_calculator_f826__table').addClass('show');
      }
    }
    if(unit == 'lbs') {
      var lbs_from = parseInt($(this).attr('data-lbs-from'));
      var lbs_to = $(this).attr('data-lbs-to');
      if(lbs_to == '+') {
        lbs_to = 99;
      } else {
        lbs_to = parseInt(lbs_to);
      }
      if(number >= lbs_from && number <= lbs_to) {
        $(this).addClass('show');
        $('.size_calculator_f826__table').addClass('show');
      }
    }
  });
}

function show_recommended_product() {
  $('#recommended-products').addClass('show');
  $('.products_ce12__product').removeClass('show');
  $('.size_calculator_f826__size').each(function(){
    if($(this).hasClass('show')) {
      var ids =  JSON.parse($(this).attr('data-products'));
      ids.forEach(function(id){
        $('.products_ce12__product').each(function(){
          if ($(this).attr('data-product-id') == id.product) {
            $(this).addClass('show');
          }
        });
      });
    }
  });
}

function show_number_of_nappies(number, unit) {
  var number_of_nappies = [];
  $('.size_calculator_f826__size').each(function(){
    if($(this).hasClass('show')) {
      number_of_nappies.push($(this).attr('data-number-of-nappies'));
    }
  });
  number_of_nappies.sort(function(a, b) {
    return a - b;
  });
  $('.size_calculator_f826__nappies_number').text(number_of_nappies.join('-'));
}

$('.size_calculator_f826__unit').on('click', function(){
  var unit = $(this).attr('data-unit');
  reset();
  if(!$(this).hasClass('active')) {
    reset();
    switch_unit(unit);
    $(this).addClass('active');
  }
});

$('#range_kg').on('change', function(){
  var value = $(this).val();
  $('.size_calculator_f826__range_slider_number').addClass('show')
  $('.size_calculator_f826__range_slider_number span').text(0 + 'kg');
  $('.size_calculator_f826__range_slider_number span').text(value + 'kg');
  show_sizes(value, 'kg');
  show_number_of_nappies();
  show_recommended_product();
});

$('#range_lbs').on('change', function(){
  var value = $(this).val();
  $('.size_calculator_f826__range_slider_number').addClass('show')
  $('.size_calculator_f826__range_slider_number span').text(0 + 'lbs');
  $('.size_calculator_f826__range_slider_number span').text(value + 'lbs');
  show_sizes(value, 'lbs');
  show_number_of_nappies();
  show_recommended_product();
});

$('#range_kg').change();

if($('.size_calculator_f826').length) {
  $('.size_calculator_f826').addClass('inactive');
  $('#recommended-products').addClass('inactive');
  $('.size_calculator_f826').on('click', function(){
    $('.size_calculator_f826').removeClass('inactive');
    $('#recommended-products').removeClass('inactive');
  });
  $('#range_kg, #range_lbs').on('change', function(){
    $('.size_calculator_f826').removeClass('inactive');
    $('#recommended-products').removeClass('inactive');
  });
}
